import _ from 'lodash';

/**
 * Get a formatted address representation of a place object.
 *
 * @param address {object} Address object
 * @returns {string} The formatted address string
 */
export function getFormattedAddress(address) {
  const city = _.get(address, 'city', '');
  const cityCode = _.get(address, 'city_code', '');
  const street = _.get(address, 'street', '');

  let formattedAddress = '';
  if (cityCode) {
    formattedAddress += cityCode;
  }
  if (city) {
    if (formattedAddress) {
      formattedAddress += ' ';
    }
    formattedAddress += city;
  }
  if (street) {
    if (formattedAddress) {
      formattedAddress = `${street}, ${formattedAddress}`;
    } else {
      formattedAddress = street;
    }
  }

  return formattedAddress;
}
